import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Data } from '@angular/router';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { NzMessageService } from 'ng-zorro-antd/message';



@Component({
  selector: 'app-sourcing-request-setting',
  templateUrl: './sourcing-request-setting.component.html',
  styleUrls: ['./sourcing-request-setting.component.scss']
})
export class SourcingRequestSettingComponent extends BaseComponent implements OnInit {
  selectedSettingKey: string = '';
  langIsSelected: boolean = false;
  loading: boolean;
  validateForm: FormGroup;
  editValidateForm: FormGroup;
  addValidateForm: FormGroup;
  settingKeyList: any[] = [];
  statList: any[] = [];
  total: number = 0;
  listOfCurrentPageData: readonly Data[] = [];
  checked = false;
  indeterminate = false;
  setOfCheckedId = new Set<number>();
  listOfData = [];
  detailData = [];
  pageIndex: number = 1;
  pageSize: number = 20;
  SRSettingStrategyMap: { [key: number]: string } = {
    0: "Common",
    1: "BySite",
    2: "ByCompany",
    3: "BySiteAndCompany",
  };
  isEditModalVisible = false;
  isAddModalVisible = false;
  languageMap: { [key: string]: string } = {
    'zh-CN': '简体中文',
    'zh-TW': '繁体中文',
    'en': '英文',
  };
  langList = Object.entries(this.languageMap).map(([value, label]) => ({ value, label }));
  editCache: { [key: string]: { edit: boolean; data: any } } = {};

  constructor(
    private LayoutComponent: LayoutComponent,
    private Environment: EnvironmentconfigService,
    private NzMessageService: NzMessageService,
    private webApiService: WebApiService,
    private fb: FormBuilder,
  ) {
    super();
  }

  ngOnInit(): void {
    this.LayoutComponent.geturl()
    this.InitConditions();
    this.validateForm = this.fb.group(
      {
        settingKey: '',
        settingValue: '',
        isEnabled: ''
      }
    );
    this.editValidateForm = this.fb.group({
      settingKey: '',
      settingValue: '',
      companyCode: '',
      lang: '',
      settingItem: '',
    });

    this.addValidateForm = this.fb.group({
      settingKey: [{ value: '', disabled: true }],
      lang: [{ value: '', disabled: true }],
      settingItem: '',
      settingValue: '',
      companyCode: '',
      siteNo: '',
    });

    this.editValidateForm.get('lang').valueChanges.subscribe(selectedLang => {
      if (selectedLang) {
        this.onLangSelected(selectedLang);
      }
      else {
        this.langIsSelected = false;
      }
    });
    this.onSearch();
  }

  InitConditions() {
    const params = {
    };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSRSettingCondition.url}`;
    this.webApiService.doGet(url, params).subscribe(
      (res) => {

        this.settingKeyList = res.settingKey;
        this.statList = res.status;
      },
      (error) => {

      }
    );
  }

  getStrategyName(strategyValue: number): string {
    return this.SRSettingStrategyMap[strategyValue] || 'Unknown Strategy';
  }

  onSearch(): void {
    this.loading = true
    const params = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      data: {
        settingKey: this.validateForm.value.settingKey,
        settingValue: this.validateForm.value.settingValue,
        isEnabled: this.validateForm.value.isEnabled,
      }
    };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSRSettingList.url}`;
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        this.listOfData = res.data
        this.total = res.total
        this.loading = false
      },
      (error) => {
        this.loading = false
      }
    );
  }

  onEdit(data: any): void {
    this.isEditModalVisible = true;
    this.selectedSettingKey = data;
    this.editValidateForm.get('settingKey').setValue(data);
  }

  onLangSelected(selectedLang: string) {
    this.langIsSelected = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GetSRSettingDetail.url}`;
    const params = {
      data: {
        settingKey: this.selectedSettingKey,
        lang: selectedLang,
      }
    }
    this.webApiService.doGetpost(url, params).subscribe(res => {
      this.detailData = res.body;
      if (this.detailData.length > 0) {
        this.updateEditCache();
      }

    });

  }

  updateEditCache(): void {
    this.detailData.forEach(Item => {
      this.editCache[Item.item] = {
        edit: false,
        data: { ...Item }
      };
    });
  }

  onAllChecked(value: boolean) {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));

    this.refreshCheckedStatus();
  };

  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);

    } else {
      this.setOfCheckedId.delete(id);
    }
    var data = []

    this.setOfCheckedId.forEach(x => {
      var dto = this.detailData.find(o => o.id == x);
      data.push(dto);
    })
  }

  onCancel(): void {
    this.isEditModalVisible = false;
    this.langIsSelected = false;
    this.editValidateForm.get('lang').setValue('');
  }

  onAddCancel(): void {
    this.isAddModalVisible = false;
    this.resetForm();
  };

  onCurrentPageDataChange(listOfCurrentPageData: readonly Data[]): void {
    this.listOfCurrentPageData = listOfCurrentPageData;

    this.refreshCheckedStatus();
  }

  onSure(event: any): void {
    const params = {
      data : this.detailData
    };
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.UpdateSRSetting.url}`;

    this.webApiService.doGetpost(url, params).subscribe(res => {
      if (res && res.body.status === '200') {
        this.isEditModalVisible = false;
        this.NzMessageService.success(res.body.msg);
      }
      else {
        this.NzMessageService.error(res.body.msg);
      }
    });
  }

  onAddSure(event: any): void {
    this.isAddModalVisible = false;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.AddSRSettingDetail.url}`;
    const params = {
      data: {
        key: this.addValidateForm.getRawValue().settingKey,
        lang: this.addValidateForm.getRawValue().lang,
        companyCode: this.addValidateForm.value.companyCode,
        siteNo: this.addValidateForm.value.siteNo,
        value: this.addValidateForm.value.settingValue,
        isEnabled: 'Y',
      }
    };
    this.webApiService.doPost(url, params).subscribe(
      (res) => {
        this.NzMessageService.success('Add Success');
        this.resetForm(); // 即使失败也可能要重置表单
        //this.onLangSelected(this.addValidateForm.getRawValue().lang);
      },
      (error) => {
        this.loading = false
        this.NzMessageService.success('Add Fail');
        this.resetForm(); // 即使失败也可能要重置表单
      }
    );
  };

  resetForm() {
    this.addValidateForm.reset({
      lang: null,
      settingKey: null,
      siteNo: null,
      companyCode: null,
      settingValue: null
    });
    this.addValidateForm.controls['lang'].disable();
    this.addValidateForm.controls['settingKey'].disable();
  }

  saveEdit(item: string): void {
    const index = this.detailData.findIndex(Item => Item.item === item);
    Object.assign(this.detailData[index], this.editCache[item].data);
    this.editCache[item].edit = false;
  }

  openAddModal() {
    this.isAddModalVisible = true;
    const selectedLangValue = this.editValidateForm.get('lang').value;
    const selectedSettingKey = this.editValidateForm.get('settingKey').value;
    if (selectedLangValue) {
      this.addValidateForm.patchValue({
        lang: selectedLangValue,
        settingKey: selectedSettingKey,
      });
    }
  }

  startEdit(item: string): void {
    this.editCache[item].edit = true;
  }

  cancelEdit(item: string): void {
    const index = this.detailData.findIndex(Item => Item.item === item);
    this.editCache[item] = {
      data: { ...this.detailData[index] },
      edit: false
    };
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(({ id }) => this.setOfCheckedId.has(id));
    this.indeterminate = this.listOfCurrentPageData.some(({ id }) => this.setOfCheckedId.has(id)) && !this.checked;

  }
  sortChange(sort: { key: string, value: string }): void {
    this.sortData(sort);
    // 可以在这里添加额外的逻辑，比如更新视图等  
  }

  sortData(sort: { key: string, value: string }): void {
    this.listOfData.sort((a, b) => {
      const modifier = sort.value === 'ascend' ? 1 : -1;
      if (a[sort.key] < b[sort.key]) {
        return -1 * modifier;
      }
      if (a[sort.key] > b[sort.key]) {
        return 1 * modifier;
      }
      return 0;
    });
  }


}
